export enum PageActionMode {
  Add = "add",
  Edit = "edit",
  View = "view"
}
